import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["backgroundColor", "textColor", "children"];
import { mediaQuery, css } from 'academy-common-lib/utils/Styling';
import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSection = styled.section.withConfig({
  displayName: "StyledSection",
  componentId: "espfpy-0"
})(["padding-block:60px;", ""], mediaQuery('notMobile', css(["padding-block:120px;"])));
const StyledSectionComponent = _ref => {
  let {
      backgroundColor,
      textColor,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({
    as: "section",
    backgroundColor: backgroundColor || 'do-not-use-olaf',
    color: textColor || undefined,
    paddingBlock: "1200"
  }, rest, {
    children: children
  }));
};
export default StyledSectionComponent;